module.exports = __webpack_public_path__ + "img/huawei-app-gallery.7b2d73a0.png";